import React from 'react';
import { Grid, styled } from '@material-ui/core';
import { theme } from 'theme';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { SdmTypography } from 'components';

const Card = styled('div')(({ isSmDown }) => ({
  padding: isSmDown ? 16 : 40,
  width: '100%',
  height: 152,
  marginTop: 25,
  backgroundColor: theme.colors.primary.white,
}));

const ActionLink = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  cursor: 'pointer',
});

const SalesMemberCard = ({
  member,
  i18n,
  onDelete,
  onEdit,
  onView,
  isSmDown,
}) => {
  const handleDelete = () => onDelete?.(member.id);
  const handleEdit = () => onEdit?.(member.id);
  const handleView = () => onView?.(member.id);
  return (
    <Card isSmDown={isSmDown}>
      <Grid container alignItems="center" style={{ height: '100%' }}>
        <Grid item md={4} sm={4} xs={6}>
          <div
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <div
              style={{
                width: isSmDown ? 50 : 80,
                height: isSmDown ? 50 : 80,
                backgroundColor: '#D8D8D8',
                borderRadius: 50,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
              }}
            >
              <SdmTypography
                variant={isSmDown ? 'h4Regular' : 'h1Regular'}
                style={{
                  width: '100%',
                  color: theme.colors.primary.black,
                }}
              >
                {member.givenName.charAt(0).toUpperCase()}{' '}
                {member.familyName.charAt(0).toUpperCase()}
              </SdmTypography>
            </div>
            <SdmTypography
              variant={isSmDown ? 'h4Regular' : 'h1Regular'}
              textAlign="center"
              style={{
                width: '100%',
                textAlign: 'center',
                color: theme.colors.primary.black,
              }}
            >
              {member.givenName} {member.familyName}
            </SdmTypography>
          </div>
        </Grid>
        <Grid item md={4} sm={4} xs={6}>
          <div
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
            }}
          >
            <SdmTypography
              variant={isSmDown ? 'h4Regular' : 'h1Regular'}
              textAlign="center"
              style={{
                width: '100%',
                textAlign: 'center',
                color: theme.colors.primary.black,
              }}
            >
              {member.role}
            </SdmTypography>
          </div>
        </Grid>
        <Grid item md={4} sm={4} xs={12}>
          <div
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              gap: 10,
              justifyContent: isSmDown ? 'center' : 'space-between',
              flexWrap: 'wrap',
            }}
          >
            <ActionLink onClick={() => handleView()}>
              <VisibilityIcon
                style={{
                  color: theme.colors.primary.red,
                  marginRight: 8,
                }}
              />
              <SdmTypography
                variant={'h4Regular'}
                margin={0}
                style={{
                  color: theme.colors.primary.red,
                  marginTop: 3,
                }}
              >
                {i18n.view}
              </SdmTypography>
            </ActionLink>
            <ActionLink onClick={() => handleEdit()}>
              <EditIcon
                style={{
                  color: theme.colors.primary.red,
                  marginRight: 8,
                }}
              />
              <SdmTypography
                variant={'h4Regular'}
                margin={0}
                style={{
                  color: theme.colors.primary.red,
                  marginTop: 3,
                }}
              >
                {i18n.edit}
              </SdmTypography>
            </ActionLink>
            <ActionLink onClick={() => handleDelete()}>
              <DeleteIcon
                style={{
                  color: theme.colors.primary.red,
                  marginRight: 8,
                }}
              />
              <SdmTypography
                variant={'h4Regular'}
                margin={0}
                style={{
                  color: theme.colors.primary.red,
                  marginTop: 3,
                }}
              >
                {i18n.delete}
              </SdmTypography>
            </ActionLink>
          </div>
        </Grid>
      </Grid>
    </Card>
  );
};
export default SalesMemberCard;
